import { Badge, Box } from '@chakra-ui/react';

export interface FaceliftBadgeProps {
	/** Status label (e.g. 'open', 'paid', 'pending', 'overdue') */
	status: string;
	/** Function to determine badge color based on status */
	badgeColor: string;
}

const FaceliftBadge: React.FC<FaceliftBadgeProps> = ({ status, badgeColor, ...rest }) => {

	return (
		<Badge borderRadius="md" bg={badgeColor} color="white" {...rest}>
			<Box textAlign={'center'} width={'full'}>
				{status}
			</Box>
		</Badge>
	);
};

export default FaceliftBadge;